import type { CopyButtonProps as MantineCopyButtonProps } from '@mantine/core';
import { CopyButton as MantineCopyButton } from '@mantine/core';

type CopyButtonProps = MantineCopyButtonProps;

export const CopyButton = (props: CopyButtonProps) => {
  return <MantineCopyButton {...props} />;
};
